import { jsxs as h, jsx as a } from "react/jsx-runtime";
import { useTheme as y } from "@lokalise/styled";
import { forwardRef as w, useState as C, useEffect as L, useMemo as E } from "react";
import I from "react-select";
import x from "react-select/async";
import A from "react-select/async-creatable";
import b from "react-select/creatable";
import { ClearIndicator as H } from "./ClearIndicator.js";
import { DropdownIndicator as O } from "./DropdownIndicator.js";
import { MultiValue as R } from "./MultiValue.js";
import { MultiValueLabel as V } from "./MultiValueLabel.js";
import { MultiValueRemove as j } from "./MultiValueRemove.js";
import { Option as k } from "./Option.js";
import { selectStyles as N, Container as D, StyledSelect as T, focusOutlineVisibilityClassName as l } from "./styles.js";
import { useInputErrorMessages as $ } from "../InputErrorMessage/useInputErrorMessages.js";
import { InputErrorMessage as P } from "../InputErrorMessage/InputErrorMessage.js";
const U = ({
  async: c,
  creatable: t,
  error: f,
  isDisabled: s,
  components: d,
  onChange: u,
  ...p
}, v) => {
  const n = y(), { isInvalid: i, errorMessages: o } = $(f), [e, S] = C(null);
  L(() => {
    if (!e)
      return;
    const r = (g) => {
      ["Tab", "ArrowUp", "ArrowDown"].includes(g.code) && e.classList.add(l);
    }, m = () => {
      e.classList.remove(l);
    };
    return e.addEventListener("mouseover", m), e.addEventListener("keydown", r), () => {
      e.removeEventListener("mouseover", m), e.removeEventListener("keydown", r);
    };
  }, [e]);
  const M = E(() => N(n), [n]);
  return /* @__PURE__ */ h(D, { ref: S, children: [
    /* @__PURE__ */ a(
      T,
      {
        disabled: s,
        isDisabled: s,
        as: (
          // eslint-disable-next-line no-nested-ternary
          c ? t ? A : x : t ? b : I
        ),
        ref: v,
        classNamePrefix: "Select",
        styles: M,
        error: i,
        "aria-invalid": i,
        "aria-errormessage": o.length > 0 ? o.map((r) => r.id).join(" ") : void 0,
        components: {
          MultiValueLabel: V,
          MultiValueRemove: j,
          MultiValue: R,
          ClearIndicator: H,
          DropdownIndicator: O,
          Option: k,
          ...d
        },
        noOptionsMessage: () => "No matches found",
        ...t ? { formatCreateLabel: (r) => `+ Add "${r}"` } : {},
        onChange: u,
        minMenuHeight: 282,
        maxMenuHeight: 282,
        ...p
      }
    ),
    o.length > 0 && /* @__PURE__ */ a(P, { children: o })
  ] });
}, te = w(U);
export {
  te as Select
};
//# sourceMappingURL=Select.js.map
